<template>
    <div class="row search-page">
        <div class="col-12 col-lg-3 pl-lg-0 pr-lg-0">
            <section class="side-section bg-white mt-2 p-4">
                <h5 v-on:click="displayShow = !displayShow">Filtre <mdb-icon icon="bars" v-on:click="displayShow = !displayShow" class="mobile-filter d-md-none d-lg-none d-xl-none"/></h5>
                <div v-if="displayShow" class=" d-md-block d-lg-block d-xl-block">
                    <div class="side-row">
                        <h6>Aktarmalar (Gidiş)</h6>
                        <div class="d-flex justify-content-center d-none" v-if="direk && birAktarma">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="direct-fly" v-model="ucusTipi" value="1" >
                            <label class="custom-control-label" for="direct-fly">Direk uçuşlar</label>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="one-fly"  v-model="ucusTipi" value="2">
                            <label class="custom-control-label" for="one-fly">1 Aktarmalı Uçuşlar</label>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="two-fly" v-model="ucusTipi" value="3">
                            <label class="custom-control-label" for="two-fly"  >2+ Aktarmalı Uçuşlar</label>
                        </div>
                    </div>
                    <div class="side-row" v-if="toDate">
                        <h6>Aktarmalar (Dönüş)</h6>
                        <div class="d-flex justify-content-center d-none" v-if="direk && birAktarma">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="direct-return-fly" v-model="ucusTipiR" value="1">
                            <label class="custom-control-label" for="direct-return-fly">Direk uçuşlar</label>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="one-return-fly" v-model="ucusTipiR" value="2">
                            <label class="custom-control-label" for="one-return-fly">1 Aktarmalı Uçuşlar</label>
                        </div>
                        <div class="custom-control custom-checkbox" >
                            <input type="checkbox" class="custom-control-input" id="two-return-fly" v-model="ucusTipiR" value="3">
                            <label class="custom-control-label" for="two-return-fly">2+ Aktarmalı Uçuşlar</label>
                        </div>
                    </div>
                    <div class="side-row d-none">
                        <h6>Uçuş Sınıfları</h6>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="busines-fly">
                            <label class="custom-control-label" for="busines-fly">Business</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="economy-fly">
                            <label class="custom-control-label" for="economy-fly">Ekonomi</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="promotion-fly">
                            <label class="custom-control-label" for="promotion-fly">Promosyon</label>
                        </div>
                    </div>
                    <div class="side-row" @click="gidisClick">
                        <h6>Gidiş Kalkış & Varış Saatleri</h6>
                        <p class="text-muted">Gidiş Saat : <span class="color-blue"><b>{{gidisKalkis[0]}}:00 - {{gidisKalkis[1]}}:00</b></span></p>
                        <vue-slider v-model="gidisKalkis" :min="0"
                                    :max="24"
                                    :interval="1" :enable-cross="false"></vue-slider>
                        <p></p>
                        <p class="text-muted">Gidiş Varış : <span class="color-blue"><b>{{gidisVaris[0]}}:00 - {{gidisVaris[1]}}:00</b></span></p>
                        <vue-slider v-model="gidisVaris" :min="0"
                                    :max="24"
                                    :interval="1" :enable-cross="false"></vue-slider>
                    </div>
                    <div class="side-row" v-if="toDate" @click="gidisClick">
                        <h6>Dönüş Kalkış & Varış Saatleri</h6>
                        <p class="text-muted">Gidiş Saat : <span class="color-blue"><b>{{donusKalkis[0]}}:00 - {{donusKalkis[1]}}:00</b></span></p>
                        <vue-slider v-model="donusKalkis" :min="0"
                                    :max="24"
                                    :interval="1" :enable-cross="false"></vue-slider>
                        <p></p>
                        <p class="text-muted">Gidiş Varış : <span class="color-blue"><b>{{donusVaris[0]}}:00 - {{donusVaris[1]}}:00</b></span></p>
                        <vue-slider v-model="donusVaris" :min="0"
                                    :max="24"
                                    :interval="1" :enable-cross="false"></vue-slider>
                    </div>
                    <div class="side-row d-none">
                        <h6>Havayolları</h6>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="anadolu-fly">
                            <label class="custom-control-label" for="anadolu-fly">Anadolu Jet</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="thy-fly">
                            <label class="custom-control-label" for="thy-fly">Türk Hava Yolları</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="pegasus-fly">
                            <label class="custom-control-label" for="pegasus-fly">Pegasus</label>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="col-12 col-lg-9 pr-lg-0">
            <div class="card p-4 mt-2" v-if="(resultsAir.length==0 && resultsRecommendAir.length==0) && !noFlight">
                <div class="d-block d-flex justify-content-center">
                    <h5>Uçuşlar Hazırlanıyor Lütfen Bekleyiniz.</h5>
                </div>
                <div class="d-flex justify-content-center" >
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                </div>
            </div>
            <div class="card p-4 mt-2"v-if="noFlight">
                <div class="d-block d-flex justify-content-center">
                    <h5>Aradığınız uçuş bulunamadı...</h5>
                </div>
            </div>
            <!--flight-list-->
            <div sticky-container :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" style="z-index: 30">
                <div v-if="(resultsRecommendAir.length>0 || resultsAir.length>0 || resultsCharterDepartureFlight.length>0) && !toDate" v-sticky sticky-offset="offset" sticky-side="top">
                    <div class="bg-middle-blue p-2">
                        <div class="row">
                            <div class="col-3 text-left"><a :href="passDay" class="text-white"> <span class="d-none d-sm-inline ">«</span> Önceki Gün</a></div>
                            <div class="col-6">
                                <h6 class="text-center"><mdb-icon icon="plane-departure" /> Gidiş <span v-if="toDate">- Dönüş</span> Uçuşları</h6>
                            </div>
                            <div class="col-3 text-right"><a :href="nextDay" class="text-white"> Sonraki Gün <span class="d-none d-sm-inline ">»</span></a></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="(resultsRecommendAir.length>0 || resultsAir.length>0 || resultsCharterDepartureFlight.length>0) && !toDate">
                <div v-if="!toDate " class="bg-light-blue p-2">
                    <p>{{formatDates(fromDate)}} <span v-if="toDate">- {{formatDates(toDate)}}</span> »  {{fromCity}} - {{toCity}} Gidiş <span v-if="toDate">- Dönüş</span> Uçuşları</p>
                    <!--<button @click="selected=undefined" v-if="selected>=0">seçimi temizle</button>-->
                </div>
            </div>
            <!--charter-gidis-->
            <section id="charter-gidis" class="pt-2" v-if="resultsCharterDepartureFlight.length>0 && (selected===undefined && toselected===undefined && recomselected===undefined)">
                <div v-if="toDate" sticky-container :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" style="z-index: 30">
                    <div v-sticky sticky-offset="offset" sticky-side="top">
                        <div class="bg-middle-blue p-2 ">
                            <div class="row">
                                <div class="col-3 text-left"><a :href="passDay" class="text-white"> <span class="d-none d-sm-inline ">«</span> Önceki Gün</a></div>
                                <div class="col-6">
                                    <h6 class="text-center"><mdb-icon icon="plane-departure" /> Gidiş </h6>
                                </div>
                                <div class="col-3 text-right"><a :href="nextDay" class="text-white"> Sonraki Gün <span class="d-none d-sm-inline ">»</span></a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="toDate" class="bg-light-blue p-2">
                    <p>{{formatDates(fromDate)}} <span v-if="toDate">- {{formatDates(toDate)}}</span> »  {{fromCity}} - {{toCity}} Gidiş <span v-if="toDate">- Dönüş</span> Uçuşları</p>
                    <button @click="charterDeparselected=undefined" v-if="charterDeparselected>=0">seçimi temizle</button>
                </div>
                <div v-for="(fromSearch,index) in resultsCharterDepartureFlight" :key="index">
                    <mdb-card class="search-card mb-2 deparFly" v-if="(charterDeparselected == index || charterDeparselected==undefined)"
                              :class="{flySelect:charterDeparselected == index}"  :id="'charter_fly'+index">
                        <mdb-card-body>
                            <div class="row px-2">
                                <div class="col-12 col-lg-9">
                                    <div class="row">
                                        <p class="flight-info col-12 p-0 mb-1">{{fromSearch.airline_name}}</p>
                                        <div class="col-1 pr-0 d-none d-md-block">
                                            <mdb-icon icon="plane-departure"  />
                                        </div>
                                        <div class="col-6 col-md-4 pl-0">
                                            <span class="hour">{{fromSearch.departure_hour}}</span>
                                            <span class="airport-name" :data-tooltip="fromName"> {{fromSearch.from_code}} </span>
                                            <span class="airport-city"> {{fromCity | truncate(10, '...')}}</span>
                                        </div>
                                        <div class="col-6 col-md-4 pl-0">
                                                    <span class="hour">{{fromSearch.arrival_hour}}</span>
                                            <span class="airport-name" :data-tooltip="toName"> {{fromSearch.to_code}} </span>
                                            <span class="airport-city"> {{toCity | truncate(10, '...')}} </span>
                                        </div>
                                        <div class="col-12 col-sm-4 col-md-3 p-0">
                                            <span class="flight-type-icon"><mdb-icon icon="clock" /></span>
                                            <span class="flight-time">{{fromSearch.duration.split(".")[0]}}h {{fromSearch.duration.split(".")[1]}}m</span>
                                            <span class="flight-type"> Direkt</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-1"></div>
                                <div class="col-12 col-lg-2 p-0">
                                    <div class="mt-2">
                                    </div>
                                    <mdb-btn color="red-price" class="m-0 btn-block px-1">{{fromSearch.adult}}₺</mdb-btn>
                                    <mdb-btn color="middle-blue" class="m-0 pl-3 pr-3 btn-block btn-blue-sec" :data-depar="index" @click="charterDeparselected = index">Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class="h-slide w-100 dt-fl">
                                    <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['non-btn detay-fly']" :toggleText="['Uçuş Detaylarını Göster']" >
                                        <div  class="mt-2 col-12 p-0">
                                            <div class="flight-details text-left">
                                                <div>
                                                    <div class="row" style="border-bottom: 1px solid #e3e3e3">
                                                        <div class="col-12 col-sm-8">
                                                            <ul class=" list-unstyled m-0">
                                                                <li>
                                                                    <span class="time">{{fromSearch.departure_hour}} {{fromSearch.date}}</span>   {{fromSearch.from_code}} {{fromSearch.from_name}} -  Havalimanı
                                                                </li>
                                                                <li>
                                                                    <span class="time">{{fromSearch.arrival_hour}} {{fromSearch.date}} </span>   {{fromSearch.to_code}} {{fromSearch.to_name}} -  Havalimanı
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-12 col-sm-4 pr-0">
                                                            <ul class="list-unstyled m-0">
                                                                <li>Uçuş No: {{fromSearch.flight_number}}</li>
                                                                <li>Sınıfı: {{fromSearch.class}}</li>
                                                                <li>Bagaj: {{fromSearch.baggage}} kg</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-collapse>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </section>
            <!--recommend-flight-->
            <section id="recommend-gidis" class="pt-2" v-if="resultsRecommendAir.length>0 && (selected===undefined && toselected===undefined && charterDeparselected === undefined && charterReturnselected === undefined)">
                <div v-if="toDate" sticky-container :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" style="z-index: 30">
                <div  v-sticky sticky-offset="offset" sticky-side="top">
                    <div class="bg-middle-blue p-2">
                        <div class="row">
                            <div class="col-3 text-left"><a :href="passDay" class="text-white"> <span class="d-none d-sm-inline ">«</span> Önceki Gün</a></div>
                            <div class="col-6">
                                <h6 class="text-center"><mdb-icon icon="plane-departure" /> Gidiş <span v-if="toDate">- Dönüş</span> Uçuşları</h6>
                            </div>
                            <div class="col-3 text-right"><a :href="nextDay" class="text-white"> Sonraki Gün <span class="d-none d-sm-inline ">»</span></a></div>
                        </div>
                    </div>
                </div>
                </div>
                <div v-if="toDate" class="bg-light-blue p-2">
                    <p>{{formatDates(fromDate)}} <span v-if="toDate">- {{formatDates(toDate)}}</span> »  {{fromCity}} - {{toCity}} Gidiş <span v-if="toDate">- Dönüş</span> Uçuşları</p>
                    <!--<button @click="selected=undefined" v-if="selected>=0">seçimi temizle</button>-->
                </div>
            </section>
            <!--flight-option-gidis-->
            <section id="gidis" class="pt-2" v-if="resultsAir.length>0 && recomselected===undefined && charterDeparselected === undefined && charterReturnselected === undefined">
                <div v-if="toDate" sticky-container :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" style="z-index: 30">
                    <div v-sticky sticky-offset="offset" sticky-side="top">
                        <div class="bg-middle-blue p-2 ">
                            <div class="row">
                                <div class="col-3 text-left"><a :href="passDay" class="text-white"> <span class="d-none d-sm-inline ">«</span> Önceki Gün</a></div>
                                <div class="col-6">
                                    <h6 class="text-center"><mdb-icon icon="plane-departure" /> Gidiş </h6>
                                </div>
                                <div class="col-3 text-right"><a :href="nextDay" class="text-white"> Sonraki Gün <span class="d-none d-sm-inline ">»</span></a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="toDate" class="bg-light-blue p-2">
                    <p>{{formatDates(fromDate)}}  »  {{fromCity}} - {{toCity}} Gidiş Uçuşları</p>
                    <button @click="selected=undefined, clearSelected = true" v-if="selected>=0">seçimi temizle</button>
                </div>

                <div v-for="(fromSearch,index) in resultsAir" :key="index" v-if="selected === undefined">
                    <ListsFlight :commission="commission" :fromSearch="fromSearch" :index="index" :clearSelected="clearSelected" :ucusTipi="ucusTipi" :flightClass="flightClass"
                                 :saatFiltre="saatFiltre" :gidisKalkis="gidisKalkis" v-if="fromSearch.type == 'flight_option'" @change="(e)=>selected = e" />
                    <ListsRecommendFlight :fromSearch="fromSearch" :index="index" :toDate="toDate" :ucusTipi="ucusTipi" :flightClass="flightClass"
                                          :saatFiltre="saatFiltre" :gidisKalkis="gidisKalkis" v-if="fromSearch.type == 'recommendation_option'"
                    @change="(e)=>{recomselected = e.recomselected, subindex = e.subindex}"
                    />
                </div>
            </section>
            <!--return-flight-->
            <section v-if="toDate && recomselected===undefined && (resultsAir.length>0 || resultsRecommendAir.length>0) && !noFlight" id="donus" class="mt-4">
                <div sticky-container :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" style="z-index: 30">
                    <div v-sticky sticky-offset="offset" sticky-side="top">
                        <div class="bg-middle-orange p-2 ">
                            <div class="row">
                                <div class="col-3 text-left"><a :href="passDayTo" class="text-white"> <span class="d-none d-sm-inline ">«</span> Önceki Gün</a></div>
                                <div class="col-6">
                                    <h6 class="text-center">Dönüş <mdb-icon icon="plane-arrival" /></h6>
                                </div>
                                <div class="col-3 text-right"><a :href="nextDayTo" class="text-white"> Sonraki Gün <span class="d-none d-sm-inline ">»</span></a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-light-orange p-2">
                    <p>{{formatDates(toDate)}}  » {{toCity}} - {{fromCity}} Dönüş Uçuşları</p>
                    <button @click="toselected=undefined" v-if="toselected>=0">seçimi temizle</button>
                </div>
                <!--charter-return-->
                <div v-if="recomselected===undefined && selected === undefined">
                    <div v-for="(fromSearch,index) in resultsCharterReturnFlight" :key="index">
                        <mdb-card class="search-card mb-2 deparFly"  :id="'charter_return_fly'+index" v-if="(charterReturnselected == index || charterReturnselected==undefined)" :class="{flySelect:charterReturnselected == index}">
                            <mdb-card-body>
                                <div class="row px-2">
                                    <div class="col-12 col-lg-9">
                                        <div class="row">
                                            <p class="flight-info col-12 p-0 mb-1">{{fromSearch.airline_name}}</p>
                                            <div class="col-1 pr-0 d-none d-md-block">
                                                <mdb-icon icon="plane-departure"  />
                                            </div>
                                            <div class="col-6 col-md-4 pl-0">
                                                <span class="hour">{{fromSearch.departure_hour}}</span>
                                                <span class="airport-name" :data-tooltip="fromName"> {{fromSearch.from_code}} </span>
                                                <span class="airport-city"> {{toCity | truncate(10, '...')}}</span>
                                            </div>
                                            <div class="col-6 col-md-4 pl-0">
                                                <span class="hour">{{fromSearch.arrival_hour}}</span>
                                                <span class="airport-name" :data-tooltip="toName"> {{fromSearch.to_code}} </span>
                                                <span class="airport-city"> {{fromCity | truncate(10, '...')}} </span>
                                            </div>
                                            <div class="col-12 col-sm-4 col-md-3 p-0">
                                                <span class="flight-type-icon"><mdb-icon icon="clock" /></span>
                                                <span class="flight-time">{{fromSearch.duration.split(".")[0]}}h {{fromSearch.duration.split(".")[1]}}m</span>
                                                <span class="flight-type"> Direkt</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-1"></div>
                                    <div class="col-12 col-lg-2 p-0">
                                        <div class="mt-2">
                                        </div>
                                        <mdb-btn color="red-price" class="m-0 btn-block px-1">{{fromSearch.adult}}₺</mdb-btn>
                                        <mdb-btn color="middle-blue" class="m-0 pl-3 pr-3 btn-block btn-blue-sec" :data-depar="index" @click="charterReturnselected = index">Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <div class="h-slide w-100 dt-fl">
                                        <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['non-btn detay-fly']" :toggleText="['Uçuş Detaylarını Göster']" >
                                            <div  class="mt-2 col-12 p-0">
                                                <div class="flight-details text-left">
                                                    <div>
                                                        <div class="row" style="border-bottom: 1px solid #e3e3e3">
                                                            <div class="col-12 col-sm-8">
                                                                <ul class=" list-unstyled m-0">
                                                                    <li>
                                                                        <span class="time">{{fromSearch.departure_hour}} {{fromSearch.date}}</span>   {{fromSearch.from_code}} {{fromSearch.from_name}} -  Havalimanı
                                                                    </li>
                                                                    <li>
                                                                        <span class="time">{{fromSearch.arrival_hour}} {{fromSearch.date}} </span>   {{fromSearch.to_code}} {{fromSearch.to_name}} -  Havalimanı
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div class="col-12 col-sm-4 pr-0">
                                                                <ul class="list-unstyled m-0">
                                                                    <li>Uçuş No: {{fromSearch.flight_number}}</li>
                                                                    <li>Sınıfı: {{fromSearch.class}}</li>
                                                                    <li>Bagaj: {{fromSearch.baggage}} kg</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mdb-collapse>
                                    </div>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
                <!--flight-option-return-->
                <div v-if="recomselected===undefined && charterDeparselected === undefined">
                    <div v-for="(fromSearch,index) in resultsAir" :key="index">
                        <mdb-card class="search-card mb-2 deparFly"
                                  :class="{flySelect:toselected == index, hide:(ucusTipiReturn(fromSearch.segments.length>1?2:1)===false && ucusTipiR.length>0) || (saatFiltre === true && (
                              (parseInt(donusKalkis[0])>=parseInt(fromSearch.segments[0].departure_time.split(':')[0]))
                              || (parseInt(donusKalkis[1])<=parseInt(fromSearch.segments[0].departure_time.split(':')[0]))
                              || (parseInt(donusVaris[0])>=parseInt(fromSearch.segments.length>1?fromSearch.segments[1].arrival_time.split(':')[0]:fromSearch.segments[0].arrival_time.split(':')[0])
                              || (parseInt(donusVaris[1])<parseInt(fromSearch.segments.length>1?fromSearch.segments[1].arrival_time.split(':')[0]:fromSearch.segments[0].arrival_time.split(':')[0])))))}" :id="'depar_fly'+index"
                                  v-if="(fromSearch.option_flag == 'IN') && (toselected == index || toselected==undefined) ">
                            <mdb-card-body>
                                <div class="row px-2">
                                    <div class="col-12 col-lg-9">
                                        <div class="row">
                                            <p class="flight-info col-12 p-0 mb-1">{{fromSearch.segments[0].marketing_airline_name}}{{fromSearch.segments[1]?" - "+fromSearch.segments[1].marketing_airline_name:""}}</p>
                                            <div class="col-1 pr-0 d-none d-md-block">
                                                <mdb-icon icon="plane-departure"  />
                                            </div>
                                            <div class="col-6 col-md-4 pl-0">
                                                <span class="hour"> {{fromSearch.segments[0].departure_time.split(":")[0]}}:{{fromSearch.segments[0].departure_time.split(":")[1]?fromSearch.segments[0].departure_time.split(":")[1]:'00'}} </span>
                                                <span class="airport-name" :data-tooltip="fromName"> {{fromSearch.segments[0].od_origin_code}} </span>
                                                <span class="airport-city d-none d-sm-inline-block"> {{toCity}} </span>
                                            </div>
                                            <div class="col-6 col-md-4 pl-0">
                                            <span class="hour"> {{fromSearch.segments.length>1?
                                                fromSearch.segments[1].arrival_time.split(":")[0]+':'+(fromSearch.segments[1].arrival_time.split(":")[1]?
                                                fromSearch.segments[1].arrival_time.split(":")[1]:'00'):
                                                fromSearch.segments[0].arrival_time.split(":")[0]+':'+(fromSearch.segments[0].arrival_time.split(":")[1]?
                                                fromSearch.segments[0].arrival_time.split(":")[1]:
                                                '00')}} </span>
                                                <span class="airport-name" :data-tooltip="toName"> {{fromSearch.segments.length>1?fromSearch.segments[1].od_destination_code:fromSearch.segments[0].od_destination_code}} </span>
                                                <span class="airport-city d-none d-sm-inline-block"> {{fromCity}} </span>
                                            </div>
                                            <div class="col-12 col-sm-4 col-md-3 p-0 my-2 my-md-0 mb-md-2">
                                                <span class="flight-type-icon"><mdb-icon icon="clock" /></span>
                                                <span class="flight-time"> {{fromSearch.duration.split(":")[0]}}h {{fromSearch.duration.split(":")[1]}}m</span>
                                                <span class="flight-type"> {{fromSearch.segments.length>1?"Aktarmalı":"Direkt"}} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-1"></div>
                                    <div class="col-12 col-lg-2 p-0">
                                        <mdb-btn color="red-price" class="m-0 px-1 btn-block">{{fromSearch.total_fare}}₺</mdb-btn>
                                        <mdb-btn v-if="!fromSearch.alternative_prices.T_AlternativePrice || !fromSearch.alternative_prices.T_AlternativePrice.length || flightClass === 'Business'" color="middle-blue" class="m-0 px-1 btn-block btn-blue-sec" :data-depar="index" @click="toselected = index, setCommission(fromSearch.total_fare)">Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                        <div class="mt-2">
                                        </div>
                                    </div>
                                </div>
                                <div class="alt-div text-right">
                                    <mdb-collapse v-if="fromSearch.alternative_prices.T_AlternativePrice && fromSearch.alternative_prices.T_AlternativePrice.length >= 3 && flightClass !== 'Business'" :toggleTag="['a']" :togglers="1" :toggleClass="['btn-mobile-block btn-blue-sec btn btn-middle-blue alternative-btn']" :toggleText="['Uçuş Seç']">
                                        <div class="col-12 px-1 text-left">
                                            <div class="row">
                                                <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[0]">
                                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.length>1">
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white ecofly">
                                                                    <h6 class="text-center">Eco Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İade edilemez.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Değiştirilemez.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                    </ul>
                                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                             color="middle-blue"
                                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                                             :data-depar="index"
                                                                             @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>

                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white ecofly">
                                                                    <h6 class="text-center">Eco Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İade edilemez.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Değiştirilemez.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                    </ul>
                                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                             color="middle-blue"
                                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                                             :data-depar="index"
                                                                             @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.LastSellerCommission))"
                                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>

                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[0].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[1]">
                                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.length>1">
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white primefly">
                                                                    <h6 class="text-center">Extra Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> 250 Ekstra Bonus Mil</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretli değişiklik</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Kesintili iade (12 saate kadar)</li>
                                                                    </ul>
                                                                    <div class="alternatif-sec">
                                                                        <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                        <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                                 color="middle-blue"
                                                                                 class="m-0 px-1 btn-block btn-blue-sec"
                                                                                 :data-depar="index"
                                                                                 @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                                                 :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                                        >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                                    </div>
                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white primefly">
                                                                    <h6 class="text-center">Extra Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> 250 Ekstra Bonus Mil</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretli değişiklik</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Kesintili iade (12 saate kadar)</li>
                                                                    </ul>
                                                                    <div class="alternatif-sec">
                                                                        <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                        <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                                 color="middle-blue"
                                                                                 class="m-0 px-1 btn-block btn-blue-sec"
                                                                                 :data-depar="index"
                                                                                 @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.LastSellerCommission))"
                                                                                 :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                                        >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                                    </div>
                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[1].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  class="col-12 col-md-4" v-if="fromSearch.alternative_prices.T_AlternativePrice[2]">
                                                    <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.length>1">
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white extrafly">
                                                                    <h6 class="text-center">Prime Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> 500 Ekstra Bonus Mil</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Cezasız değişiklik</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Kesintisiz iade (12 saate kadar)</li>
                                                                    </ul>
                                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                             color="middle-blue"
                                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                                             :data-depar="index"
                                                                             @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.LastSellerCommission))"
                                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.TotalFare"
                                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare[0].FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem" >
                                                            <mdb-card testimonial>
                                                                <mdb-card-up  class="lighten-1 text-white extrafly">
                                                                    <h6 class="text-center">Prime Fly</h6>
                                                                    <p class="text-center">({{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BookingClassCode}} Sınıf)</p>
                                                                </mdb-card-up>
                                                                <mdb-card-body>
                                                                    <ul class="list-unstyled">
                                                                        <li v-for="baggage in fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BrandedMinuRules.FreeBaggageAllowance.FBA.PaxBaggageAllowance">
                                                                            <mdb-icon icon="angle-double-right" /> {{baggage.PaxFBA?baggage.PaxFBA.Allowance:""}} kg
                                                                            <span v-if="baggage.PaxFBA && baggage.PaxFBA.Type==='Weight'">Bagaj hakkı</span>
                                                                            <span v-else>El Bagajı</span>
                                                                        </li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Ücretsiz koltuk seçimi.</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> İkram</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> 500 Ekstra Bonus Mil</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Cezasız değişiklik</li>
                                                                        <li><mdb-icon icon="angle-double-right" /> Kesintisiz iade (12 saate kadar)</li>
                                                                    </ul>
                                                                    <h5 class="text-red text-center price">{{ calcCommission(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.LastSellerCommission) }} <span class="text-muted">TRY</span></h5>
                                                                    <mdb-btn v-if="fromSearch.alternative_prices.T_AlternativePrice"
                                                                             color="middle-blue"
                                                                             class="m-0 px-1 btn-block btn-blue-sec"
                                                                             :data-depar="index"
                                                                             @click="toselected = index, brandclick(fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.BrandedMinuRules.BrandCode,fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.ProductItemId,2, (fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare - fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.LastSellerCommission))"
                                                                             :data-brndprice="fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.TotalFare"
                                                                    >Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                                                    <p class="d-none">{{fromSearch.alternative_prices.T_AlternativePrice[2].BrandedFares.BrandedFare.FareItem.ProductItemId}}</p>
                                                                </mdb-card-body>
                                                            </mdb-card>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-collapse>
                                </div>
                                <div class="h-slide w-100 dt-fl">
                                    <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['non-btn detay-fly']" :toggleText="['Uçuş Detaylarını Göster']" >
                                        <div  class="mt-2 col-12 p-0">
                                            <div class="flight-details text-left">
                                                <div class="row" v-for="(aktarma,index) in fromSearch.segments" :key="index" style="border-bottom: 1px solid #e3e3e3">
                                                    <div class="col-8">
                                                        <ul class="pl-2 pl-md-4 pl-lg-4 pl-xl-5">
                                                            <li>
                                                                <span class="time">{{aktarma.departure_time}}</span>   {{aktarma.origin_code}} - {{aktarma.origin_name}}  Havalimanı
                                                            </li>
                                                            <li>
                                                                <span class="time">{{aktarma.arrival_time}}</span>    {{aktarma.destination_code}} - {{aktarma.destination_name}} Havalimanı
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="col-4 pr-0">
                                                        <ul class="list-unstyled">
                                                            <li>Uçuş No: {{aktarma.flight_number}}</li>
                                                            <li>Sınıfı: {{aktarma.booking_class}}</li>
                                                            <li>Bagaj: {{fromSearch.baggage?fromSearch.baggage.allowance:""}} {{fromSearch.baggage?fromSearch.baggage.type === 'Weight'?"kg":"Parça":""}}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-collapse>
                                </div>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </div>
                <!--<mdb-card class="search-card mb-2" :class="{flySelect:toselected == index, hide:ucusTipiReturn(aktarmali)===false && ucusTipiR.length>0}" v-for="(fromSearch,index) in resultsAir" :key="index" v-if="fromSearch.option_flag == 'IN' && (toselected == index || toselected==undefined)">
                    {{flightTimes(fromSearch.segments)}}
                    <mdb-card-body>
                        <p class="flight-info">{{MarketingAirline}}</p>
                        <div class="row">
                            <div class="col-1 pr-0 d-none d-md-block">
                                <mdb-icon icon="plane-departure" size="2x" />
                            </div>
                            <div class="col-4 col-md-3 col-lg-2 p-lg-0">
                                <div class="hour">{{departureTime}}</div>
                                <div class="airport-city">{{toCity}}</div>
                                <div class="airport-name" :data-tooltip="toName">({{OD_DestinationCode}})</div>
                            </div>
                            <div class="col-4 col-md-3 col-lg-2 p-0 pr-md-4 text-center">
                                <div class="flight-time">{{duration(fromSearch.duration)}} {{durationHour}} sa {{durationMinute}} dk</div>
                                <div class="flight-type-icon"><mdb-icon icon="plane" /></div>
                                <div class="flight-type">{{aktarmali==1?"Direkt":"Aktarmalı"}}</div>
                                <div class="flight-air-code" v-if="aktarmali>1">({{firstAktarma}})</div>
                            </div>
                            <div class="col-4 col-lg-3 pl-lg-4">
                                <div class="hour">{{arrivalTime}}</div>
                                <div class="airport-city">{{fromCity}}</div>
                                <div class="airport-name" :data-tooltip="fromName">({{OD_OriginCode}})</div>
                            </div>
                            <div class="col-12 col-lg-4 px-md-0 mt-3 mt-md-0 mt-lg-0 mt-xl-0 text-right">
                                <mdb-btn color="red-price" class="m-0 btn-mobile-block">{{fromSearch.total_fare}}₺</mdb-btn>
                                <mdb-btn color="middle-blue" class="m-0 pl-3 pr-3 btn-mobile-block" @click="toselected = index">Seç <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                                <div class="mt-2">


                                </div>
                            </div>
                            <div class="h-slide w-100 dt-fl text-right">
                                <mdb-collapse :toggleTag="['a']" :togglers="1" :toggleClass="['non-btn detay-fly']" :toggleText="['Uçuş Detaylarını Göster']" >
                                    <div  class="mt-2 col-12 p-0">
                                        <div class="flight-details text-left">
                                            <div class="row" v-for="(aktarma,index) in fromSearch.segments" :key="index" style="border-bottom: 1px solid #e3e3e3">
                                                <div class="col-8">
                                                    <ul class="pl-2 pl-md-4 pl-lg-4 pl-xl-5">
                                                        <li>
                                                            <span class="time">{{aktarma.departure_time}}</span>    {{aktarma.origin_code}} - {{aktarma.origin_name}} Havalimanı
                                                        </li>
                                                        <li>
                                                            <span class="time">{{aktarma.arrival_time}}</span>    {{aktarma.destination_code}} - {{aktarma.destination_name}} Havalimanı
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-4 pr-0">
                                                    <ul class="list-unstyled">
                                                        <li>Uçuş No: {{aktarma.flight_number}}</li>
                                                        <li>Sınıfı: {{aktarma.booking_class}}</li>
                                                        <li>Bagaj: {{fromSearch.baggage.allowance}} kg</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mdb-collapse>
                            </div>

                        </div>
                    </mdb-card-body>
                </mdb-card>-->
            </section>
            <!--<section class="mt-4" v-if="(toDate && ((resultsAir.length>0 && selected>=0 && toselected>=0) || (resultsAir.length==0 && selected>=0))) || (!toDate && selected>=0)">
                <div class="d-none" v-if="resultsAir.length>0">-->
            <section class="mt-4" v-if="(toDate && ((resultsAir.length>0 && selected>=0 && toselected>=0) || (resultsAir.length==0 && selected>=0))) || (!toDate && selected>=0)">
                <div class="d-none" v-if="(toDate && ((selected>=0 && toselected>=0) || (selected>=0))) || (!toDate && selected>=0)">
                    {{dp_product_id = resultsAir[selected].product_id}} {{dp_service_fee=resultsAir[selected].last_seller_commission }}
                    {{toselected>=0?rt_product_id = resultsAir[toselected].product_id:''}} {{toselected>=0?rt_service_fee=resultsAir[toselected].last_seller_commission:''}}
                </div>

                <mdb-card class="biletbul-bg-blue d-none">
                    <mdb-card-body>
                        <div class="row">
                            <div class="col-12 col-md-8">
                                <div class="row">
                                    <div class="col-12 col-md-8 text-md-right">
                                        <p class="total-pay">TOPLAM FİYAT :</p>
                                    </div>
                                    <div class="col-12 col-md-4 text-md-left">
                                        <p class="total-amount" v-if="resultsAir.length>0">{{toDate?(parseFloat(resultsAir[selected].total_fare)+parseFloat(resultsAir[toselected].total_fare)).toFixed(2):resultsAir[selected].total_fare}} TRY</p>
                                        <p class="total-amount" v-else>{{resultsRecommendAir[selected].total_fare}} TRY</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-8 text-md-right">
                                        <p class="total-puan">TOPLAM KAZANACAĞIN PUAN :</p>
                                    </div>
                                    <div class="col-12 col-md-4 text-md-left">
                                        <p class="total-bil"> X Puan (X TRY)</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <mdb-btn tag="a" href="/#/rezervasyon"  color="red-price" class="btn-mobile-block">Devam <mdb-icon icon="angle-double-right"></mdb-icon></mdb-btn>
                            </div>
                        </div>
                    </mdb-card-body>
                </mdb-card>

            </section>
            <div class="d-none" v-if="recomselected>=0" >
            {{dp_product_id_recommend = resultsAir[recomselected].product_id }}
            {{dp_service_fee = resultsAir[recomselected].last_seller_commission}}
            {{sub_options[0]=resultsAir[recomselected].departure_flight[subindex].flight_id}}
            {{toDate?sub_options[1]=resultsAir[recomselected].return_flight[subindex].flight_id:sub_options[0]=resultsAir[recomselected].departure_flight[subindex].flight_id}}
            </div>
            <div class="d-none" v-if="charterDeparselected>=0">
                {{departure_charter_id = resultsCharterDepartureFlight[charterDeparselected].id}}
            </div>
            <div class="d-none" v-if="toDate && charterReturnselected>=0">
                {{ return_charter_id = resultsCharterReturnFlight[charterReturnselected].id}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbView, mdbBtn, mdbCard, mdbCardHeader,mdbCardUp, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText,mdbCollapse, mdbStretchedLink,} from 'mdbvue';
    import format from 'date-fns/format';
    import axios from "axios";
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css'
    import ListsFlight from '@/components/ListsFlight'
    import ListsRecommendFlight from '@/components/ListsRecommendFlight'
    export default {
        name: "searchMain",
        components:{
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbView,
            mdbBtn,
            mdbCard,
            mdbCardHeader,
            mdbCardUp,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCollapse,
            mdbStretchedLink,
            VueSlider,
            ListsFlight,
            ListsRecommendFlight
        },
        data() {
            return {
                commission: [],
                userToken: "",
                lazyloadData:[],
                scrollPosition: null,
                testUrl:"flight",
                noFlight:false,
                displayShow:false,
                ucusTipi:[],
                ucusTipiR:[],
                dateFormat: 'D MMMM YYYY',
                dateFormatDay:'ddd',
                dateFormatSql: 'YYYY-MM-DD',
                collapse: false,
                return2: false,
                show: true,
                flightType:"",
                fromCity:"",
                fromCountry:"",
                fromIsCity:"",
                fromName:"",
                toCity:"",
                toCountry:"",
                toIsCity:"",
                toName:"",
                fromAir :"",
                toAir :"",
                fromDate :"",
                toDate :"",
                adult :"",
                child :"",
                infant :"",
                ecofly:"",
                extrafly:"",
                primefly:"",
                ecoflyR:"",
                extraflyR:"",
                primeflyR:"",
                resultsAir:[],
                resultsCharterDepartureFlight:[],
                resultsCharterReturnFlight:[],
                resultsRecommendAir:[],
                durationHour:"",
                durationMinute:"",
                departureTime:"",
                arrivalTime:"",
                OD_OriginCode:"",
                OD_DestinationCode:"",
                aktarmali :1,
                MarketingAirline:"",
                sessionAll:[],
                recomselected:undefined,
                subindex:undefined,
                subrindex:undefined,
                charterDeparselected:undefined,
                charterReturnselected:undefined,
                selected:undefined,
                toselected:undefined,
                firstAktarma:"",
                window: {
                    width: 0,
                    height: 0
                },
                clearSelected: false,
                departure_charter_id:"",
                return_charter_id:"",
                dp_product_id:"",
                dp_product_id_recommend:"",
                departure_branded_code:"",
                departure_product_id:"",
                return_branded_code:"",
                return_product_id:"",
                sub_options:[],
                dp_service_fee:"",
                rt_product_id:"",
                rt_service_fee:"",
                ucusDeparSaatiParcali:[],
                ucusArrivalSaatiParcali:[],
                gidisKalkisSaatK:"",
                gidisKalkisSaatB:"",
                gidisKalkis: [0, 24],
                gidisVaris: [0, 24],
                donusKalkis: [0, 24],
                donusVaris: [0, 24],
                birdenFazla:false,
                birAktarma:false,
                direk:false,
                passDay :"",
                nextDay:"",
                passDayTo :"",
                nextDayTo:"",
                saatFiltre:false,
            };
        },
        filters: {
            truncate: function (text, length, suffix) {
                return text.substring(0, length) + (length < text.length ? suffix || '...' : '');
            },
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed:{},
        methods:{
          debug (event) {
            console.log(event)
          },
            gidisClick(){
                this.saatFiltre=true;
            },
            brandFareType(tip,deger){
                if(tip === "eco"){
                    this.ecofly = "";
                    this.ecofly = deger;
                }
                if(tip === "ext"){
                    this.extrafly = "";
                    this.extrafly = deger;
                }
                if(tip === "prm"){
                    this.primefly = "";
                    this.primefly = deger;
                }
            },
            brandclick(code,id,tur, fare = 0){
                if(tur === 1) {
                    this.departure_branded_code = code;
                    this.departure_product_id = id;
                    localStorage.departure_branded_code = this.departure_branded_code;
                    localStorage.departure_product_id = this.departure_product_id;
                    localStorage.departure_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
                } else {
                    this.return_branded_code = code;
                    this.return_product_id = id;
                    localStorage.return_branded_code = this.return_branded_code;
                    localStorage.return_product_id = this.return_product_id;
                    localStorage.return_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
                }
            },
            setCommission(fare = 0) {
              localStorage.return_commission = (this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)).toFixed(2);
            },
            calcCommission(fare) {
              return ((this.commission.type == "percentage" ? parseFloat(fare * this.commission.value / 100) : parseFloat(this.commission.value)) + parseFloat(fare)).toFixed(2);
            },
            ucusTipiF(n) {
                return this.ucusTipi.indexOf(n.toString()) > -1
            },
            ucusTipiReturn(n) {
                return this.ucusTipiR.indexOf(n.toString()) > -1
            },
            duration(times){

                let parcaTimes = times.split(":");

                this.durationHour = parcaTimes[0];
                this.durationMinute = parcaTimes[1];
            },
            recomduration(times){

                let parcaReTimes = times.split(":");

                this.durationHour = parcaReTimes[0];
                this.durationMinute = parcaReTimes[1];
            },
            returnFlightControl(fromSearch){
                if(fromSearch.return_flight.length===0){
                    return fromSearch.return_flight = [{bos:'bos'}];
                }
            },
            recomflightTimes(segment){
                if(segment.length>1){
                    this.birAktarma = true;
                    if(segment[0].marketing_airline_name === segment[1].marketing_airline_name){
                        this.MarketingAirline = segment[0].marketing_airline_name;
                    }else{
                        this.MarketingAirline = segment[0].marketing_airline_name +" - "+segment[1].marketing_airline_name;
                    }
                    this.aktarmali = segment.length;
                    this.OD_OriginCode = segment[0].departure_airport_code;
                    this.OD_DestinationCode = segment[1].arrival_airport_code;
                    this.firstAktarma = segment[0].arrival_airport_code;
                    if(segment[0].departure_time){
                        this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                        if(this.ucusDeparSaatiParcali[1]){
                            this.departureTime = segment[0].departure_time;
                        }else{
                            this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                        }
                        if(segment[1].arrival_time){
                            this.ucusArrivalSaatiParcali = segment[1].arrival_time.split(":");
                            if(this.ucusArrivalSaatiParcali[1]){
                                this.arrivalTime = segment[1].arrival_time;
                            }else{
                                this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                            }
                        }
                    }
                }else{
                    if(segment){
                        this.aktarmali = 1;
                        this.direk=true;
                        this.MarketingAirline = segment[0].marketing_airline_name;
                        this.OD_OriginCode = segment[0].departure_airport_code;
                        this.OD_DestinationCode = segment[0].arrival_airport_code;
                        if(segment[0].departure_time){
                            this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                            if(this.ucusDeparSaatiParcali[1]){
                                this.departureTime = segment[0].departure_time;
                            }else{
                                this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                            }
                            if(segment[0].arrival_time){
                                this.ucusArrivalSaatiParcali = segment[0].arrival_time.split(":");
                                if(this.ucusArrivalSaatiParcali[1]){
                                    this.arrivalTime = segment[0].arrival_time;
                                }else{
                                    this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                                }
                            }

                        }

                        /*this.departureTime = segment[0].departure_time;
                        this.arrivalTime = segment[0].arrival_time;*/
                        this.firstAktarma = segment[0].destination_code;
                    }

                }
            },
            flightTimes(segment){
                if(segment.length>1){
                    this.birAktarma = true;
                    /*this.MarketingAirline = segment[0].marketing_airline_name +" - "+segment[1].marketing_airline_name;
                    this.aktarmali = segment.length;
                    this.OD_OriginCode = segment[0].od_origin_code;
                    this.OD_DestinationCode = segment[1].od_destination_code;
                    this.firstAktarma = segment[0].destination_code;*/

                    this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                    if(this.ucusDeparSaatiParcali[1]){
                        this.departureTime = segment[0].departure_time;
                    }else{
                        this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                    }
                    if(this.ucusDeparSaatiParcali[0]==="00"){
                        this.ucusDeparSaatiParcali[0]=24;
                    }

                    this.ucusArrivalSaatiParcali = segment[1].arrival_time.split(":");
                    if(this.ucusArrivalSaatiParcali[1]){
                        this.arrivalTime = segment[1].arrival_time;
                    }else{
                        this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                    }

                    if (this.ucusArrivalSaatiParcali[0] === "00") {
                        this.ucusArrivalSaatiParcali[0] = 24;
                    }
                } else {
                    this.aktarmali = 1;
                    this.direk=true;
                    this.MarketingAirline = segment[0].marketing_airline_name;
                    this.OD_OriginCode = segment[0].od_origin_code;
                    this.OD_DestinationCode = segment[0].od_destination_code;
                    this.ucusDeparSaatiParcali = segment[0].departure_time.split(":");
                    if(this.ucusDeparSaatiParcali[1]){
                        this.departureTime = segment[0].departure_time;
                    }else{
                        this.departureTime = this.ucusDeparSaatiParcali[0] + ":00";
                    }
                    if(this.ucusDeparSaatiParcali[0]==="00"){
                        this.ucusDeparSaatiParcali[0]=24;
                    }
                    this.ucusArrivalSaatiParcali = segment[0].arrival_time.split(":");
                    if(this.ucusArrivalSaatiParcali[1]){
                        this.arrivalTime = segment[0].arrival_time;
                    }else{
                        this.arrivalTime = this.ucusArrivalSaatiParcali[0] + ":00";
                    }
                    if(this.ucusArrivalSaatiParcali[0]==="00"){
                        this.ucusArrivalSaatiParcali[0]=24;
                    }
                    this.firstAktarma = segment[0].destination_code;
                }
            },
            formatDates(fromDate, dateTwo,dateType) {
                let formattedDates = '';
                if (fromDate) {
                    formattedDates = format(fromDate, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                if (dateType){
                    if (dateType == 1){
                        formattedDates = format(fromDate, this.dateFormatDay)
                    }else{
                        formattedDates = format(fromDate, this.dateFormatSql)
                    }
                }
                return formattedDates;
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width>768){
                    this.displayShow = true;
                }else{
                    this.displayShow = false;
                }
            },
            params:function(){
                const urlParams = new URLSearchParams(window.location.search);
                this.fromAir = urlParams.get('from');
                this.fromCountry = urlParams.get('fromCountry');
                this.fromIsCity = urlParams.get('fromIsCity');
                this.fromCity = urlParams.get('fromCityName');
                this.fromName = urlParams.get('fromName');
                this.toAir = urlParams.get('to');
                this.toCountry = urlParams.get('toCountry');
                this.toIsCity = urlParams.get('toIsCity');
                this.toCity = urlParams.get('toCityName');
                this.toName = urlParams.get('toName');
                this.fromDate = urlParams.get('fromdate');
                this.toDate = urlParams.get('todate');
                this.adult = urlParams.get('adult');
                this.child = urlParams.get('child');
                this.infant = urlParams.get('infant');
                this.flightType = urlParams.get('flight_type');
                this.if_direct_flight_only = urlParams.get('if_direct_flight_only');
                this.flightClass = urlParams.get('flight_class');
                localStorage.flightClass = this.flightClass;
                this.testUrl = urlParams.get('test_url');
                localStorage.sessionToken = this.sessionAll.session_token;
                localStorage.sessionId = this.sessionAll.session_id;
                let fromDay = new Date(this.fromDate);
                fromDay.setDate(fromDay.getDate() - 1);
                let passDate = fromDay.getFullYear() +"-"+("0"+ (fromDay.getMonth()+1)).slice(-2)+"-"+("0"+fromDay.getDate()).slice(-2);
                fromDay.setDate(fromDay.getDate() + 2);
                let nextDate = fromDay.getFullYear() +"-"+("0"+ (fromDay.getMonth()+1)).slice(-2)+"-"+("0"+fromDay.getDate()).slice(-2);
                let toDay = new Date(this.toDate);
                toDay.setDate(toDay.getDate() - 1);
                let passDateTo = toDay.getFullYear() +"-"+("0"+ (toDay.getMonth()+1)).slice(-2)+"-"+("0"+toDay.getDate()).slice(-2);
                toDay.setDate(toDay.getDate() + 2);
                let nextDateTo = toDay.getFullYear() +"-"+("0"+ (toDay.getMonth()+1)).slice(-2)+"-"+("0"+toDay.getDate()).slice(-2);
                let toDateVar = "",fromDateVar = "";
                if(this.flightType ==="RT"){
                    fromDateVar = "&fromdate="+this.fromDate;
                    toDateVar = "&todate="+this.toDate;
                }
                this.passDay = "?flight_type="+this.flightType+"&from="+this.fromAir+"&fromCityName="+this.fromCity+"&fromName="+this.fromName+"&fromCountry="+this.fromCountry+"&fromIsCity="+this.fromIsCity+"&to="+this.toAir+"&toCityName="+this.toCity+"&toName="+this.toName+"&toCountry="+this.toCountry+"&toIsCity="+this.toIsCity+"&fromdate="+passDate+toDateVar+"&adult="+this.adult+"&child="+this.child+"&infant="+this.infant+"&flight_class="+this.flightClass+"#/search";
                this.nextDay = "?flight_type="+this.flightType+"&from="+this.fromAir+"&fromCityName="+this.fromCity+"&fromName="+this.fromName+"&fromCountry="+this.fromCountry+"&fromIsCity="+this.fromIsCity+"&to="+this.toAir+"&toCityName="+this.toCity+"&toName="+this.toName+"&toCountry="+this.toCountry+"&toIsCity="+this.toIsCity+"&fromdate="+nextDate+toDateVar+"&adult="+this.adult+"&child="+this.child+"&infant="+this.infant+"&flight_class="+this.flightClass+"#/search";
                this.passDayTo = "?flight_type="+this.flightType+"&from="+this.fromAir+"&fromCityName="+this.fromCity+"&fromName="+this.fromName+"&fromCountry="+this.fromCountry+"&fromIsCity="+this.fromIsCity+"&to="+this.toAir+"&toCityName="+this.toCity+"&toName="+this.toName+"&toCountry="+this.toCountry+"&toIsCity="+this.toIsCity+fromDateVar+"&todate="+passDateTo+"&adult="+this.adult+"&child="+this.child+"&infant="+this.infant+"&flight_class="+this.flightClass+"#/search";
                this.nextDayTo = "?flight_type="+this.flightType+"&from="+this.fromAir+"&fromCityName="+this.fromCity+"&fromName="+this.fromName+"&fromCountry="+this.fromCountry+"&fromIsCity="+this.fromIsCity+"&to="+this.toAir+"&toCityName="+this.toCity+"&toName="+this.toName+"&toCountry="+this.toCountry+"&toIsCity="+this.toIsCity+fromDateVar+"&todate="+nextDateTo+"&adult="+this.adult+"&child="+this.child+"&infant="+this.infant+"&flight_class="+this.flightClass+"#/search";
                this.axiosCall();
            },
            async loginCall() {
                var self = this;
                await axios.get("https://www.biletbul.com/backend/public/api/v1/flight/login", {})
                    .then(function (response) {
                        if (response.data.status == true) {
                            self.sessionAll = response.data.data;
                            self.params();
                        }
                        /*response => this.sessionAll = [response.data.data]*/
                    });
                /*this.params();*/
            },
            async axiosCall() {
                localStorage.flight_type = this.flightType;
                localStorage.from_code = this.fromAir;
                localStorage.from_is_city = this.fromIsCity;
                localStorage.from_city_name = this.fromCity;
                localStorage.from_country_code = this.fromCountry;
                localStorage.to_code = this.toAir;
                localStorage.to_is_city = this.toIsCity;
                localStorage.to_city_name = this.toCity;
                localStorage.to_country_code = this.toCountry;
                localStorage.departure_date = this.fromDate;
                localStorage.return_date = this.toDate;
                localStorage.adult = this.adult;
                localStorage.child = this.child;
                localStorage.infant = this.infant;
                var self = this;
                if (this.fromAir) {
                    let basePath = "https://www.biletbul.com/backend/public/api/v1/";
                    let url = basePath + "flight/result";
                    if (this.testUrl === "test") {
                        url = basePath + "test";
                    }
                    await axios.post(url, {
                        /*from: this.fromAir,
                        to: this.toAir,
                        adult: this.adult,
                        child: this.child,
                        infant: this.infant,
                        ddate: this.fromDate,
                        rdate: this.toDate,*/
                        flight_type: this.flightType,
                        session_id: this.sessionAll.session_id,
                        session_token: this.sessionAll.session_token,
                        from_code: this.fromAir,
                        from_is_city: this.fromIsCity,
                        from_city_name: this.fromCity,
                        from_country_code: this.fromCountry,
                        to_code: this.toAir,
                        to_is_city: this.toIsCity,
                        to_city_name: this.toCity,
                        to_country_code: this.toCountry,
                        departure_date: this.fromDate,
                        return_date: this.toDate,
                        adult: this.adult,
                        child: this.child,
                        infant: this.infant,
                        if_direct_flight_only: this.if_direct_flight_only,
                        flight_class: this.flightClass,
                        airlines: "",
                        userToken: localStorage.getItem('api_token')
                    })
                        .then(function (response) {
                            /*response => self.resultsAir=[...response.data.data.result]*/
                            self.commission = response.data.data.user;
                            self.resultsAir = response.data.data.result;
                            if(!Array.isArray(response.data.data.charter_options)){
                                if(response.data.data.charter_options.departure_flight.length>0){
                                    self.resultsCharterDepartureFlight = response.data.data.charter_options.departure_flight;
                                }
                                if(response.data.data.charter_options.return_flight!==null){
                                    self.resultsCharterReturnFlight = response.data.data.charter_options.return_flight;
                                }
                            }
                            self.noFlight = false
                            /*if (response.data.status == true) {
                                if (response.data.data.flight_options.length === 0) {
                                    if (response.data.data.recommendations.length === 0) {
                                        if(response.data.data.charter_options.length === 0) {
                                            self.noFlight = true;
                                        }else{
                                            self.noFlight = false;
                                            self.resultsCharterDepartureFlight = response.data.data.charter_options.departure_flight;
                                            self.resultsCharterReturnFlight = response.data.data.charter_options.return_flight;
                                        }
                                    } else {
                                        self.noFlight = false;
                                        self.resultsRecommendAir = response.data.data.recommendations;
                                        if(response.data.data.charter_options.length > 0) {
                                            self.resultsCharterDepartureFlight = response.data.data.charter_options.departure_flight;
                                            self.resultsCharterReturnFlight = response.data.data.charter_options.return_flight;
                                        }
                                    }
                                } else {
                                    if (response.data.data.recommendations.length > 0) {
                                        if(response.data.data.charter_options.length > 0) {
                                            self.noFlight = false;
                                            self.resultsCharterDepartureFlight = response.data.data.charter_options.departure_flight;
                                            self.resultsCharterReturnFlight = response.data.data.charter_options.return_flight;
                                        }
                                        self.noFlight = false;
                                        self.resultsRecommendAir = response.data.data.recommendations;
                                        self.resultsAir = response.data.data.flight_options;
                                        self.noFlight = false;
                                    } else {
                                        if(response.data.data.charter_options.length > 0) {
                                            self.noFlight = false;
                                            self.resultsCharterDepartureFlight = response.data.data.charter_options.departure_flight;
                                            self.resultsCharterReturnFlight = response.data.data.charter_options.return_flight;
                                        }
                                        self.resultsAir = response.data.data.flight_options;
                                        self.noFlight = false;
                                    }
                                }
                            }*/
                        });
                }
                /*.then(response => this.airports=[...response.data]);*/
            },
            updateScroll() {
                this.scrollPosition = window.scrollY
            }
        },
        watch:{
            resultsRecommendAir:function(){
                let self = this;
                /*this.resultsRecommendAir.filter(function(fromsearch,i){
                    fromsearch.return_flight.filter(function (returnflys,k) {
                        returnflys.segments.filter(function (returnfly,d) {
                            fromsearch.departure_flight.filter(function (deparflys,e) {
                                deparflys.segments.filter(function (deparfly,z) {
                                    self.lazyloadData.push(deparfly);
                                })
                            })
                        })
                    });
                });
                console.log(self.lazyloadData);*/
            },
            departure_charter_id:function(){
                localStorage.departure_charter_id = this.departure_charter_id;
                if(this.toDate){
                    if(this.return_charter_id){
                        window.location.href="/#/rezervasyon";
                    }
                }else{
                    window.location.href="/#/rezervasyon";
                }

            },
            return_charter_id:function(){
                localStorage.return_charter_id = this.return_charter_id;
                if(this.toDate){
                    if(this.departure_charter_id){
                        window.location.href="/#/rezervasyon";
                    }
                }

            },
            dp_product_id_recommend:function(){
                localStorage.product_id = this.dp_product_id_recommend;
                localStorage.dp_service_fee = this.dp_service_fee;
                localStorage.rt_product_id = "";
                localStorage.rt_service_fee =this.rt_service_fee;
                localStorage.sub_options = this.sub_options;
                window.location.href="/#/rezervasyon";
            },
            dp_product_id:function(){
                localStorage.dp_product_id = this.dp_product_id;
                localStorage.dp_service_fee = this.dp_service_fee;
                localStorage.rt_product_id = "";
                localStorage.rt_service_fee =this.rt_service_fee;
                if(this.toDate){
                    if(this.rt_product_id){
                        window.location.href="/#/rezervasyon";
                    }
                }else{
                    window.location.href="/#/rezervasyon";
                }
            },
            rt_product_id:function(){
              localStorage.rt_product_id = this.rt_product_id;
              localStorage.rt_service_fee = this.rt_service_fee;
            },
            gidisVaris:function () {
                if(parseInt(this.gidisVaris[1]) === 24){
                    this.saatFiltre=false;
                }
            },
            donusVaris:function () {
                if(parseInt(this.gidisVaris[1]) === 24){
                    this.saatFiltre=false;
                }
            }
        },
        mounted(){
            window.addEventListener('scroll', this.updateScroll);
            if(localStorage.sessionId){
                localStorage.removeItem("sessionId");
                localStorage.removeItem("sessionToken");
                localStorage.removeItem("departure_branded_code");
                localStorage.removeItem("departure_product_id");
                localStorage.removeItem("departure_commission");
                localStorage.removeItem("return_commission");
                localStorage.removeItem("departure_time");
                localStorage.removeItem("dp_product_id");
                localStorage.removeItem("dp_service_fee");
                localStorage.removeItem("return_branded_code");
                localStorage.removeItem("return_time");
                localStorage.removeItem("return_product_id");
                localStorage.removeItem("rt_product_id");
                localStorage.removeItem("rt_service_fee");
                localStorage.removeItem("total_fares");
                localStorage.removeItem("sub_options");
                localStorage.removeItem("flightClass");
                localStorage.removeItem("departure_charter");
                localStorage.removeItem("arrival_charter");
                localStorage.removeItem("persons");
                localStorage.removeItem("amount_paid");
            }
            if(localStorage.departure_charter_id){
                localStorage.removeItem("departure_charter");
                localStorage.removeItem("departure_charter_id");
                localStorage.removeItem("arrival_charter");
                localStorage.removeItem("return_charter_id");
                localStorage.removeItem("persons");
                localStorage.removeItem("amount_paid");
            }
            if(localStorage.billing_name){
                localStorage.removeItem("billing_name");
                localStorage.removeItem("tax_office");
                localStorage.removeItem("tax_number");
                localStorage.removeItem("address_detail");
                localStorage.removeItem("zip_code");
                localStorage.removeItem("address_district");
                localStorage.removeItem("city");
            }
            if (localStorage.sub_options){
                localStorage.removeItem("sub_options");
            }
            this.loginCall();
        }
    }
</script>

<style scoped>

</style>
